/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useEffect, useState, useReducer } from 'react';
import axios from 'axios';
import queryString from 'query-string';

import creatBlobFromBase64 from '../../helpers/utils';
import Back from '../common/Back';
import Table from '../common/Table';
import Format from '../../helpers/format';
import PrimaryButton from '../common/PrimaryButton';
import filterReducer from '../../reducers/filter.reducer';
import filterActions from '../../actions/filter.actions';

import style from './DocumentsPage.module.css';

const DocumentsPage = React.memo(({ match, history }) => {
  const [clientInfo, setClientInfo] = useState({
    name: '',
    clientId: '',
  });

  const [state, dispatch] = useReducer(filterReducer, {
    filterChanged: false,
  });

  const [data, setData] = useState({ data: [], pages: -1 });

  const { clientId } = match.params;

  const queryParameters = history.location.search;
  const params = new URLSearchParams(queryParameters);
  let pageState = {
    draw: params.get('draw') || 0,
    page: +params.get('page') || 0,
    pageSize: +params.get('pageSize') || 10,
    sortField: params.get('sortField') || '',
    sortDesc: params.get('sortDesc') || true,
  };

  const onClick = event => {
    event.preventDefault();

    history.push(`/clients/${clientId}/requests/policy-document`);
  };

  const viewDocument = documentId => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}documents/${clientId}/files/${documentId}/content`,
      )
      .then(response => {
        const blob = creatBlobFromBase64(
          response.data.Content,
          response.data.ContentType,
        );
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.data.FileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          if (response.data.ContentType === 'application/pdf') {
            window.open(url);
          } else {
            const a = window.document.createElement('a');
            window.document.body.appendChild(a);
            a.style = 'display: none';
            a.href = url;
            a.download = response.data.FileName;
            a.click();
            setTimeout(() => {
              window.document.body.removeChild(a);
            }, 0);
          }
        }
      });
  };

  useEffect(() => {
    if (!clientId) return;

    const handleClientInformationSuccess = ({ data: info }) => {
      setClientInfo({ name: info.Name, clientId: info.ClientId });
    };

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}agency/clients/${clientId}/information`,
      )
      .then(handleClientInformationSuccess);

    history.push(
      `${history.location.pathname}?${queryString.stringify(pageState)}`,
    );
  }, []);

  useEffect(() => {
    if (!clientId) return;
    const requestUrl = `${
      process.env.REACT_APP_BASE_URL
    }documents/${JSON.stringify(clientId).replace(
      /"/g,
      '',
    )}/default?${queryString.stringify(pageState)}`;

    axios(requestUrl)
      .then(response => {
        setData({
          data: response.data.data,
          pages: Math.ceil(response.data.recordsTotal / pageState.pageSize),
        });
      })
      .catch();
  }, [clientId, state]);

  const onTableStateChanged = changes => {
    pageState = { ...pageState, ...changes };
    history.push(
      `${history.location.pathname}?${queryString.stringify(pageState)}`,
    );

    dispatch({ type: filterActions.FILTER_CHANGED_SUCCESS });
  };

  const columns = [
    {
      Header: 'Document Name',
      accessor: 'FileName',
      width: 280,
    },
    {
      Header: 'Date Created',
      accessor: 'CreationDate',
      Cell: cell => Format.formatDate(cell.value),
      width: 100,
      maxWidth: 100,
    },
    {
      Header: '',
      sortable: false,
      accessor: 'DocumentId',
      className: 'btn-column',
      Cell: cell => {
        return (
          <div className={style.btnPair}>
            <a
              className={style.btn}
              style={{ width: '60px', cursor: 'pointer' }}
              onClick={() => viewDocument(cell.value)}
            >
              View
            </a>
          </div>
        );
      },
    },
  ];

  return (
    <div className={style.documents}>
      <Back
        path={`/clients/${clientId}`}
        text={clientInfo.name}
        clientId={clientInfo.clientId}
      />
      <div className={style.header}>
        <h1>View Documents</h1>
        <PrimaryButton
          text="Request Policy Document"
          type="button"
          onClick={onClick}
          styles={{
            width: '200px',
            margin: 0,
            height: '43px',
            lineHeight: '40px',
            fontSize: '15px',
            letterSpacing: '-.2px',
            boxSizing: 'content-box',
          }}
        />
      </div>
      <Table
        data={data.data}
        page={pageState.page}
        pages={data.pages}
        pageSize={pageState.pageSize}
        collapseOnPageChange={false}
        entityNameText="documents"
        columns={columns}
        manual
        onPageChange={newValue => onTableStateChanged({ page: newValue })}
        onPageSizeChange={newValue =>
          onTableStateChanged({ pageSize: newValue })
        }
        onSortedChange={newValue =>
          onTableStateChanged({
            sortField: newValue[0] ? newValue[0].id : '',
            sortDesc: newValue[0] ? newValue[0].desc : true,
          })
        }
        style={{ width: '100%', marginTop: '20px' }}
        pageSizeOptions={[5, 10, 25, 50, 10000]}
      />
    </div>
  );
});

DocumentsPage.propTypes = {};

export default DocumentsPage;
